import styled from "styled-components";

import { SimpleUserInitialsNameContainer } from "shared/components/atoms/SimpleUserInitials/styles";
import { SimpleUserPhotoContainer } from "shared/components/atoms/SimpleUserPhoto/styles";

import { LexicalEditorInnerContainer } from "@LexicalEditor/component/organisms/LexicalEditorInner/styles";
import { EditorToolbar } from "@LexicalEditor/plugins/ToolbarPlugin/styles";
import { EditorContainer } from "@LexicalEditor/styles";
import { DialogBase } from "@LexicalEditor/styles/DialogBase";
import { EditorDropdown } from "@LexicalEditor/styles/EditorDropdown";

interface ICreatePostEditorContainerProps {}
export const CreatePostEditorContainer = styled.div<ICreatePostEditorContainerProps>`
  --padding-button-xs: 6px;
  border-radius: 4px;

  width: 100%;

  background-color: ${({ theme }) => theme.groups.backgroundComponentsMural};
  box-shadow: inset 0px 0px 0px 2px
    ${({ theme }) => theme.groups.borderColorComponentsMural};

  display: flex;
  position: relative;
  gap: 0.25rem;

  padding: 0.75rem;
  transition: all var(--editor-collapse-animation-time) ease-in-out;

  @media (max-width: 900px) {
    border-radius: 0;
  }

  @media (max-width: 768px) {
    display: grid;
    gap: 0.5rem;
    grid-template-columns: auto 1fr;
  }

  ${SimpleUserPhotoContainer},
  ${SimpleUserPhotoContainer} > img,
  ${SimpleUserInitialsNameContainer} {
    width: 32px !important;
    height: 32px !important;
    h1 {
      background-color: ${({ theme }) => theme.groups.primaryText};
    }
  }

  ${LexicalEditorInnerContainer} {
    .editor-input {
      border: none;
      min-height: min-content;
      padding: 0.25rem;
    }

    .editor-placeholder {
      top: 0.35rem;
      left: 0.5rem;

      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  ${EditorContainer} {
    position: initial;

    display: flex;
    flex-direction: column-reverse;
  }

  ${DialogBase},
  ${EditorDropdown} {
    width: min-content;
    max-width: min-content;
    bottom: 0.25rem;
    top: unset;
  }

  ${DialogBase} {
    min-width: 10rem;
  }

  ${EditorToolbar} {
    transition: all 0.1s ease-in-out;
    opacity: 1;
    pointer-events: all;
    height: auto;
    padding: 4px;
    overflow: hidden;
    gap: 0.25rem;
    border: none;

    button {
      padding: var(--padding-button-xs);
    }
  }
`;

export const LexicalEditorContainer = styled.div`
  transition: all var(--editor-collapse-animation-time) ease-in-out;

  grid-column: 1 / -1;

  align-items: end;
  display: flex;
  flex-direction: column;

  width: 100%;

  > .loader {
    width: 24px;
    height: 24px;

    margin-top: 1rem;
    align-self: center;

    svg {
      stroke: white;
      fill: white;
    }
  }
`;
